import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

import Faq from '@/features/support/faq/pages/FaqPage'
import Inquiry from '@/features/support/inquiry/pages/InquiryPage'
import News from '@/features/support/news/pages/NewsPage'
import NoticeDetail from '@/features/support/notice/pages/NoticeDetailPage'
import Notice from '@/features/support/notice/pages/NoticePage'
import Refund from '@/features/support/refund/pages/RefundPage'
import { CenterTab, CenterTabContent, CenterWrap } from '@/styles/views/Support'

const Center = () => {
  const tabRefs = useRef<(HTMLAnchorElement | null)[]>([])

  const CenterOption = [
    { title: '공지사항', component: <Notice />, path: '/notice', padding: '20px' },
    { title: '새소식', component: <News />, path: '/news', padding: '29.5px' },
    { title: '자주묻는질문', component: <Faq />, path: '/faq', padding: '17px' },
    { title: '서비스 환불', component: <Refund />, path: '/refund', padding: '24px' },
    { title: '1:1문의', component: <Inquiry />, path: '/inquiry', padding: '25px' },
  ]
  const { pathname } = useLocation()
  const FindItem = (element: any) => {
    return element.path === pathname
  }

  useEffect(() => {
    const index = CenterOption.findIndex((option) => option.path === pathname)
    if (index !== -1 && tabRefs.current[index]) {
      tabRefs.current[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center' })
    }
  }, [pathname])

  return (
    <CenterWrap>
      <CenterTab>
        {CenterOption.map(
          (option: { title: string; component: any; path: string; padding: string }, index) => (
            <CenterTabContent
              ref={(el) => (tabRefs.current[index] = el)}
              to={option.path}
              padding={option.padding}
              active={`${pathname.indexOf(option.path) === 0}`}
              key={option.title}
            >
              {option.title}
            </CenterTabContent>
          ),
        )}
      </CenterTab>
      {CenterOption?.find(FindItem)?.component}
      {pathname.indexOf('detail') > 0 && <NoticeDetail />}
    </CenterWrap>
  )
}
export default Center
